import React from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import './stocktransfer.css';
import { Grid, Input, Popup } from 'semantic-ui-react';
import Tables from './tables';
import ReadCookie from '../../../functions/readcookies';

class Inbound extends React.Component {

  state = {
    data: [],
    openView: false,
    viewbound: [],
    desc: 'none',
    descbutton: 'none',
    updateviewbound: [],
    load: false,
    branch: 0,
    message: ''
  }

  componentDidMount() {
    this.getInBound();
  }

  componentDidUpdate(props) {
    if (props.selectedBranch != this.props.selectedBranch) {
      this.getInBound();
    }
  }

  getInBound() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Stock In!!!'
    });
    let branch = this.props.selectedBranch;
    let data1 = { 'branch' : branch, 'userId': userId };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'stocktransfer/getinbound.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({ data: data })
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  view(value, type) {
    let context = this;
    if (type == 'view') {
      context.setState({
        load: true,
        message: 'Getting Stock In!!!',
        openView: true,
        desc: 'none',
        descbutton: 'show',
        descbutton1: 'none',
      });
    }
    else {
      context.setState({
        load: true,
        message: 'Getting Stock In!!!',
        openView: true,
        desc: 'show',
        descbutton: 'none',
        descbutton1: 'show',
      });
    }

    let data1 = { 'value' : value };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'stocktransfer/viewinbound.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          let branch;
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
            branch = data[i].branch;
          }
          context.setState ({ viewbound: data, branch: branch})
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  handleClose = (val) => {
    if (val == 'yes') {
      this.setState({ openView: false  });
      this.getInBound();
      return;
    }
    else {
      this.setState({ openView: false  });
    }
  };

  search() {
    let search = document.getElementById('search').value;
    this.setState({
      search: search,
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  convertTOUpperCase(value) {
    try {
      value = value.toUpperCase();
    } catch (e) {
      value = '';
    }
    return value;
  }

  downloadPdf(id) {
    let open = Server() + "pdf/stocktransferpdfcreation/transfer.php?id="+id;
    window.open(open);
  }

  convertToNumber(value) {
    try {
      value = Number(value).toFixed(2);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  dateFormat(value) {
    let date = value.split(' ')[0];
    let time = value.split(' ')[1];
    return date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0]+' '+time;
  }

  render() {
    return (
      <div style={{display: this.props.stockinview, padding: '0.5%'}}><br/>
      <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <b>Search Branch</b><br/>
            <Input focus id="search"
            icon='search' onChange={this.search.bind(this)} fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <b>From Date</b><br/>
            <input type="date" id="from_date"
              style={{width: '100%', height: 35 }} onChange={this.handleChange('from_date')} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <b>To Date</b><br/>
            <input type="date" id="to_date"
              style={{width: '100%', height: 35 }} onChange={this.handleChange('to_date')} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            { this.state.data ?
              (
                <div>
                <table width='100%' id='table'>
                  <tr>
                    <th id='tableheader'>SiNo</th>
                    <th id='tableheader'>Voucher No</th>
                    <th id='tableheader'>From Branch</th>
                    <th id='tableheader'>Time</th>
                    <th id='tableheader'>By</th>
                    <th id='tableheader'>Stocks</th>
                    <th id='tableheader'>Amount</th>
                    <th id='tableheader'>View</th>
                    <th style={{cursor: 'pointer', display: this.props.stockinedit}} id='tableheader'>Shortage</th>
                  </tr>
                  {this.state.data.map((z) => {
                    let from_date = this.state.from_date;
                    let to_date = this.state.to_date;
                    let value = this.convertToNumber(z.value);
                    let times = this.dateFormat(z.times);
                    if (this.state.search) {
                      let word = z.from_branch;
                      let search = this.state.search;
                      search = this.convertTOUpperCase(search);
                      word = this.convertTOUpperCase(word);
                      let substring = word.includes(search);
                      if (substring == true) {
                        return (
                          <tbody>
                            <Popup content={<div>
                                <div>
                                  <b>Remarks: </b>{z.remarks}
                                </div><br/>
                                <div>
                                  <b>Refrence ID: </b>{z.reference}
                                </div><br/>
                              </div>} trigger={
                              <tr>
                                <td><center>{z.sino}</center></td>
                                <td style={{cursor: 'pointer', color: '#5EA2D7'}} onClick={this.downloadPdf.bind(this, z.id)}><u>{z.voucher_no}</u></td>
                                <td>{z.from_branch}</td>
                                <td><center>{times}</center></td>
                                <td>{z.employee}</td>
                                <td><center>{z.stocks}</center></td>
                                <td><center>{value}</center></td>
                                <td style={{cursor: 'pointer'}}>
                                <center onClick={this.view.bind(this, z.id, 'view')}>view</center>
                                </td>
                                <td style={{cursor: 'pointer', display: this.props.stockinedit}}>
                                  <center onClick={this.view.bind(this, z.id, 'show')}>
                                    Shortage
                                  </center>
                                </td>
                              </tr>
                            }/>
                          </tbody>
                        );
                      }
                    }
                    else if (from_date && to_date) {
                      from_date = from_date+" "+"00:00:00";
                      to_date = to_date+" "+"00:00:00";
                      if (from_date < z.times && to_date > z.times) {
                        return (
                          <tbody>
                            <Popup content={<div>
                                <div>
                                  <b>Remarks: </b>{z.remarks}
                                </div><br/>
                                <div>
                                  <b>Refrence ID: </b>{z.reference}
                                </div><br/>
                              </div>} trigger={
                              <tr>
                                <td><center>{z.sino}</center></td>
                                <td style={{cursor: 'pointer', color: '#5EA2D7'}} onClick={this.downloadPdf.bind(this, z.id)}><u>{z.voucher_no}</u></td>
                                <td>{z.from_branch}</td>
                                <td><center>{times}</center></td>
                                <td>{z.employee}</td>
                                <td><center>{z.stocks}</center></td>
                                <td><center>{value}</center></td>
                                <td style={{cursor: 'pointer'}}>
                                <center onClick={this.view.bind(this, z.id, 'view')}>view</center>
                                </td>
                                <td style={{cursor: 'pointer', display: this.props.stockinedit}}>
                                  <center onClick={this.view.bind(this, z.id, 'show')}>
                                    Shortage
                                  </center>
                                </td>
                              </tr>
                            }/>
                          </tbody>
                        );
                      }
                      else {

                      }
                    }
                    else {
                      return (
                        <tbody>
                          <Popup content={<div>
                              <div>
                                <b>Remarks: </b>{z.remarks}
                              </div><br/>
                              <div>
                                <b>Refrence ID: </b>{z.reference}
                              </div><br/>
                            </div>} trigger={
                            <tr>
                              <td><center>{z.sino}</center></td>
                              <td style={{cursor: 'pointer', color: '#5EA2D7'}} onClick={this.downloadPdf.bind(this, z.id)}><u>{z.voucher_no}</u></td>
                              <td>{z.from_branch}</td>
                              <td><center>{times}</center></td>
                              <td>{z.employee}</td>
                              <td><center>{z.stocks}</center></td>
                              <td><center>{value}</center></td>
                              <td style={{cursor: 'pointer'}}>
                              <center onClick={this.view.bind(this, z.id, 'view')}>view</center>
                              </td>
                              <td style={{cursor: 'pointer', display: this.props.stockinedit}}>
                                <center onClick={this.view.bind(this, z.id, 'show')}>
                                  Shortage
                                </center>
                              </td>
                            </tr>
                          }/>
                        </tbody>
                      );
                    }
                  }
                )}
                </table>
                </div>
              ) :
              (
                <div>
                  <center>There is no Stock In data!!!</center>
                </div>
              )
            }
          </Grid.Column>
        </Grid>
        { (this.state.viewbound.length > 0) ?
          (
            <div>
              <Tables viewbound = {this.state.viewbound} display={this.props.shortageview}
              openView={this.state.openView} handleClose={this.handleClose.bind(this)}
              branch={this.state.branch} />
            </div>
          ) :
          (
            <div>

            </div>
          )
        }
      </div>
    );
  }
}

export default Inbound;
